export enum STORE_DEVICE {
  POS = 'POS',
  HAND = 'HAND',
  BUDDY = 'BUDDY'
}
